import { useNavigate } from "react-router-dom";
import { useRdt } from "../../../../hooks/useRdt";
import { SubTitle } from "../../../../globalStyles"
import { PropertyButtonWrapper, PropertyCardWrapper, 
    PropertyCardWrapperTr, 
    PropertyDescriptionWrapper, 
    PropertyImageWrapper, 
    PropertyInfoWrapper, 
    PropertyValueWrapper } from "./styles"
import { ButtonIconRemove } from "../../../../components/ButtonIconRemove"
import { IoTrashOutline, 
        IoRemoveCircleOutline,
        IoRadioButtonOffOutline,
        IoArrowBackCircleOutline,
        IoArrowBack,
        IoDuplicate,
        IoAddCircleOutline,
        IoSave, 
        IoSend} from "react-icons/io5";
import swal from 'sweetalert';
import { HTTP_VERBS, requestHttp } from "../../../../utils/HttpRequest";
import { getToken } from "../../../../utils/TokenLS";
import { showAlert, SW_ICON } from "../../../../utils/swAlert";
import { getCurrencyFormat } from "../../../../utils/CurrencyFormat";

export const PropertyRdts = (item) =>{   

    const { setReload } = useRdt();

    const navigate = useNavigate();

    //Validar dia de la semana
    const fechaComoCadena = item.dtmFecha_rdd.split('T')[0] +  " 00:01:59"; // día semana
    const dias = [
        'DOMINGO',
        'LUNES',
        'MARTES',
        'MIERCOLES',
        'JUEVES',
        'VIERNES',
        'SABADO',
    ];
    const numeroDia = new Date(fechaComoCadena).getDay();
    const nombreDia = dias[numeroDia];

    const fecha = new Date(fechaComoCadena);
    //hoy
    const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);

    const rango = new Date(hoy - fecha);
    

    //Delete RDTNews
    const showAlertYN = (id) =>{
        //console.log({id: id})
        //Vallido que si este dentro de un rango permitido para eliminar
        //Validaciones
        //Vallido que si este dentro de un rango permitido para registrar
        //rango para el sabado de 3 dias.                     
        if(rango > 276999999){
        //if(rango > 363599999){ //Festivo dia lunes
            showAlert('Error', "Registro esta fuera del tiempo permitido para eliminar", SW_ICON.ERROR);             
            return      
        }
        swal({
            title: "Esta usted seguro?",
            text: "Una vez eliminado, no podras recuperar este registro!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {   
                rdtDelete(id)                
            } else {
            //swal("Su registro esta a salvo!");
            return
            }
            //console.log(willDelete)
        });
    }
    const rdtDelete = async (id) =>{             
        try {           
            const response = await requestHttp(
                {
                    method: HTTP_VERBS.DELETE,
                    endpoint: `/rdds/${id}`,               
                    token: getToken()               
                }
            );
            setReload(true)   
            showAlert(
                'RDT', 
                "Eliminado Correctamente", 
                SW_ICON.SUCCESS,   
                () => { navigate('/addRdds')}                 
            );                              
                
            } catch (error) { 
                if(error.response.status === 401){
                    //hendleCloseSeccion();
                }else{
                    showAlert('Error', "Eliminación Incorrecta", SW_ICON.ERROR);
                }            
            }        
    } 

    return (
    
        <PropertyCardWrapperTr>
            <PropertyCardWrapper to={`/RddsDetail/${item._id}`}>               
                <PropertyInfoWrapper>
                    {item.strNombreTrabajador} 
                        <SubTitle>
                            <span>{item.IntCodigo_EMPL} </span>&nbsp;{item.strNombre_SUCU}&nbsp;&nbsp;<span></span>&nbsp;  
                            <span></span>&nbsp;<span>{item.strConcepto}&nbsp;{getCurrencyFormat(item.intTotal_rdd)}</span>&nbsp;                             
                            {item.strObservacion_rdd}
                        </SubTitle>
                </PropertyInfoWrapper>               
            </PropertyCardWrapper>
            <PropertyButtonWrapper>
                <ButtonIconRemove icon={IoTrashOutline} onPress={()=>showAlertYN(item._id)} />
            </PropertyButtonWrapper>
        </PropertyCardWrapperTr>    
          
          
    )
}